import { createPopper, Instance } from "@popperjs/core";
import { debounce } from "debounce";
import { ICintorinConfig } from "./common/interfaces";

declare const CintorinConfig: ICintorinConfig;

var popupRoot = document.createElement("div");
popupRoot.id = "quickSearchRoot";
var popup:Instance;
var isPopupReady = false;
var loadingTask = Promise.resolve();
var hidePopupHandler = debounce(hidePopup, 200);

function quickSearchResultClicked() {
    if (this.getAttribute("data-cemetery-id") && this.getAttribute("data-cemetery-search-term")) {
        (document.getElementById("obec") as HTMLInputElement).value = this.getAttribute("data-cemetery-search-term");
        document.getElementById("obec").setAttribute("data-cemetery-id", this.getAttribute("data-cemetery-id"));
        hidePopup();
        isPopupReady = false;
        document.getElementById("obec").focus();
    }
}

function hidePopup() {
    popupRoot.parentElement.removeAttribute("data-show-quicksearch");
}

function showPopup() {
    if (isPopupReady) {
        popupRoot.parentElement.setAttribute("data-show-quicksearch", "");
        popup.update();
    }
}

function quickSearch() {
    document.getElementById("obec").removeAttribute("data-cemetery-id");
    let searchTerm = (document.getElementById("obec") as HTMLInputElement)?.value?.trim();
    isPopupReady = false;
    if (searchTerm?.length > 1) {
        loadingTask = loadingTask.then(() =>
            fetch(CintorinConfig.baseUrl+"/api/htmlCemeteryQuickSearch.php", {
                method: "POST",
                headers: new Headers({
                    'Content-Type': 'application/x-www-form-urlencoded'
                }),
                body: "city="+encodeURIComponent(searchTerm)
            }).then(response => {
                if (response.ok) {
                    return response.text();
                }
            }).then(text => {
                if (text) {
                    popupRoot.innerHTML = text;
                    let items = popupRoot.getElementsByTagName("li");
                    for (let i=0; i<items.length; i++) {
                        items.item(i).addEventListener("click", quickSearchResultClicked);
                        items.item(i).addEventListener("keydown", itemKeyDown);
                    }
                    isPopupReady = true;
                    showPopup();
                }
            })
        );
    } else {
        hidePopup();
    }
}

function handleKeyDown(e: KeyboardEvent) {
    if (e.key == "Tab" || e.key == "ArrowDown") {
        let searchInput = document.getElementById("obec") as HTMLInputElement;
        let isPreset = searchInput.hasAttribute("data-cemetery-id");
        let searchTerm = searchInput?.value?.trim();
        if (!isPreset && searchTerm.length > 1) {
            let firstChild = popupRoot.querySelector("li");
            if (firstChild?.tagName == "LI") {
                e.preventDefault();
                firstChild.focus();
                hidePopupHandler.clear();
                showPopup();
            }
        }
    } else if (e.key == "Enter") {
        hidePopup();
    }
}

function itemKeyDown(e: KeyboardEvent) {
    if (e.key == "Tab") {
        let nextLi = this.nextElementSibling;
        if (e.shiftKey) {
            nextLi = this.previousElementSibling;
        }
        if (nextLi?.tagName == "LI") {
            e.preventDefault();
            nextLi.focus();
            hidePopupHandler.clear();
        } else if (e.shiftKey) {
            document.getElementById("obec").focus();
            hidePopupHandler.clear();
        }
    } else if (e.key == "Enter") {
        quickSearchResultClicked.bind(this)();
    } else if (e.key == "ArrowUp") {
        let previousLi = this.previousElementSibling;
        if (previousLi != null && previousLi.tagName == "LI") {
            e.preventDefault();
            previousLi.focus();
            hidePopupHandler.clear();
        }
    }  else if (e.key == "ArrowDown") {
        let nextLi = this.nextElementSibling;
        if (nextLi != null && nextLi.tagName == "LI") {
            e.preventDefault();
            nextLi.focus();
            hidePopupHandler.clear();
        }
    }
}

document.addEventListener("readystatechange", () => {
    if (document.readyState === 'complete') {
        if (document.getElementById("obec")) {
            let popupAnchor = document.getElementById("obec").parentElement.parentElement;
            popupAnchor.insertBefore(popupRoot, popupAnchor.querySelector("span.dismiss-button"));
            popup = createPopper(popupAnchor, popupRoot, {modifiers: [{name: "flip", enabled: false}]});
            document.getElementById("obec").addEventListener("focusin", showPopup);
            document.getElementById("obec").addEventListener("focusout", hidePopupHandler);
            document.getElementById("obec").addEventListener("input", quickSearch);
            document.getElementById("obec").addEventListener("keydown", handleKeyDown);
            popupRoot.addEventListener("focusout", hidePopupHandler);
        }
    }
});